var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[(_vm.isVisible)?_c('router-view',{attrs:{"groupName":_vm.groupName},on:{"update-user-home":_vm.updateUserHome}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }